import React, { FC } from "react";
import { IDatabaseOptionResource, IServerOptionResource } from "~shared/types/product_deployment";

interface Props {
	databases: IDatabaseOptionResource[];
	server: IServerOptionResource;
}

export const DatabaseInfo: FC<Props> = ({ databases, server }) => {
	return (
		<ul>
			{databases.map((database) => (
				<DatabaseDetail key={database.id} database={database} server={server} />
			))}
		</ul>
	);
};

export const DatabaseDetail: FC<{ database: IDatabaseOptionResource; server: IServerOptionResource }> = ({
	database,
	server,
}) => {
	return (
		<li>
			<a
				href={`https://${server.name}/adm/index.php?route=/database/structure&server=1&db=${database.name}`}
				target="_blank" rel="noreferrer"
			>
				<span>
					<b>{database.type}</b>: {database.name}
				</span>
			</a>
		</li>
	);
};
